<template>
  <el-form ref="mnForm" :model="mnForm" :rules="mnRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备型号" prop="deviceModel">
          <el-input
            v-if="!isDetail()"
            v-model="mnForm.deviceModel"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ mnForm.deviceModel || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="出厂编号" prop="factoryNo">
          <el-input
            v-if="!isDetail()"
            v-model="mnForm.factoryNo"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ mnForm.factoryNo || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="MN" prop="mnNum">
          <el-input v-if="!isDetail()" v-model="mnForm.mnNum" placeholder="请输入"></el-input>
          <span v-else>{{ mnForm.mnNum }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备状态" prop="status">
          <el-select v-if="!isDetail()" v-model="mnForm.status" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.typeName"
              :value="item.type"
            ></el-option>
          </el-select>
          <span v-else>{{ typeObj[mnForm.status] }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="接口" prop="interface">
          <el-input
            v-if="!isDetail()"
            v-model="mnForm.interface"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ mnForm.interface || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="标准" prop="standard">
          <el-input
            v-if="!isDetail()"
            v-model="mnForm.standard"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ mnForm.standard || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="容量" prop="capacity">
          <el-input
            v-if="!isDetail()"
            v-model="mnForm.capacity"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ mnForm.capacity || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="通讯" prop="communication">
          <el-input
            v-if="!isDetail()"
            v-model="mnForm.communication"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ mnForm.communication || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="显示" prop="show">
          <el-input
            v-if="!isDetail()"
            v-model="mnForm.show"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ mnForm.show || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="电池" prop="battery">
          <el-input
            v-if="!isDetail()"
            v-model="mnForm.battery"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ mnForm.battery || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="系统" prop="sys">
          <el-input
            v-if="!isDetail()"
            v-model="mnForm.sys"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ mnForm.sys || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      typeList: [
        { type: 0, typeName: '启用' },
        { type: 1, typeName: '停用' }
      ],
      typeObj: {
        0: '启用',
        1: '停用'
      },
      mnForm: {}
    };
  },
  inject: ['isDetail'],

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.mnForm = newVal;
      }
    },
    mnForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    }
  },
  computed: {
    mnRules() {
      return {
        status: [{ required: !this.isDetail(), message: '请选择设备状态', trigger: 'change' }],
        mnNum: [{ required: !this.isDetail(), message: '请输入MN号', trigger: 'blur' }]
      };
    }
  },
  methods: {
    getNationNo() {
      // getNationNum().then(res => {
      //   if (!res.success) {
      //     return;
      //   }
      //   this.mnForm.mnNum = res.data
      // });
    },

    reset() {
      this.$refs.mnForm.resetFields();
    },
    getData() {
      let data = {
        deviceModel: this.mnForm.deviceModel,
        factoryNo: this.mnForm.factoryNo,
        status: this.mnForm.status,
        mn: this.mnForm.mnNum,
        interfaceType: this.mnForm.interface,
        standard: this.mnForm.standard,
        capacity: this.mnForm.capacity,
        communicate: this.mnForm.communication,
        display: this.mnForm.show,
        cell: this.mnForm.battery,
        system: this.mnForm.sys
      };
      return data;
    },
    setData(data) {
      const {
        deviceModel,
        factoryNo,
        status,
        mn,
        interfaceType,
        standard,
        capacity,
        communicate,
        display,
        cell,
        system
      } = data;
      this.mnForm.deviceModel = deviceModel;
      this.mnForm.factoryNo = factoryNo;
      this.mnForm.status = status;
      this.mnForm.mnNum = mn;
      this.mnForm.interface = interfaceType;
      this.mnForm.standard = standard;
      this.mnForm.capacity = capacity;
      this.mnForm.communication = communicate;
      this.mnForm.show = display;
      this.mnForm.battery = cell;
      this.mnForm.sys = system;
    },
    validate() {
      let type;
      this.$refs.mnForm.validate(validated => {
        type = validated;
      });
      return type;
    }
  }
};
</script>

